import { AiSectionProps } from './AiSection';
import GatewayDiagram from './diagrams/GatewayDiagram';
import GraphRagDiagram from './diagrams/GraphRagDiagram';
import McpChatDemo from './demos/McpChatDemo';
import AgentChatDemo from './demos/AgentChatDemo';
import RagSearchDemo from './demos/RagSearchDemo';

/**
 * AI 랜딩 주제 섹션 정의.
 * 섹션마다 시각 양식을 달리해(허브 · 채팅 · 검색결과 · 그래프 · 에이전트 트레이스)
 * 동일 패턴 반복을 피하고 기술 깊이를 드러낸다.
 */
export const AI_SECTIONS: AiSectionProps[] = [
  {
    index: 0,
    eyebrow: 'A2A · MCP GATEWAY',
    title: '에이전트 통신의 중심',
    titleAccent: 'A2A · MCP Gateway',
    descriptions: [
      '여러 AI 에이전트와 도구를 안전하게 연결하는 게이트웨이를 구축합니다.',
      'A2A(Agent-to-Agent)와 MCP를 단일 진입점에서 중계·표준화합니다.',
    ],
    tags: ['A2A', 'MCP', '표준 프로토콜', '단일 진입점'],
    visual: <GatewayDiagram />,
  },
  {
    index: 1,
    eyebrow: 'MCP SERVER',
    title: '공공서비스를 LLM에 연결',
    titleAccent: 'MCP Server',
    descriptions: [
      '공공서비스·공공데이터를 LLM이 직접 호출(tool-calling)하도록 MCP 서버를 설계·구축합니다.',
      '공유시설 예약 등 서비스와 일기예보·미세먼지·실시간 지하철 등 데이터를 실시간으로 연계합니다.',
    ],
    tags: ['tool-calling', '공공서비스', '공공데이터', '실시간 API'],
    visual: <McpChatDemo />,
    reverse: true,
  },
  {
    index: 2,
    eyebrow: 'VECTORDB + RAG',
    title: '근거 기반 검색 증강 생성',
    titleAccent: 'VectorDB + RAG',
    descriptions: [
      '문서를 임베딩해 적재하고, 하이브리드 검색·리랭킹으로 가장 정확한 근거를 찾습니다.',
      '데이터 프로파일링으로 품질을 확보하고, 출처를 인용해 환각을 줄입니다.',
    ],
    tags: ['임베딩', '하이브리드 검색', '리랭킹', '데이터 프로파일링'],
    visual: <RagSearchDemo />,
  },
  {
    index: 3,
    eyebrow: 'GRAPHDB + GRAPHRAG',
    title: '관계 기반 추론',
    titleAccent: 'GraphDB + GraphRAG',
    descriptions: [
      '지식 그래프로 개체 간 관계를 구조화하고, 그래프를 탐색해 다단계 질의에 대응합니다.',
      '엔티티 링킹과 삼분(tripartite) 그래프 구조로 설명 가능한 근거를 제공합니다.',
    ],
    tags: ['지식그래프', 'tripartite graph', '엔티티 링킹', '다단계 추론'],
    visual: <GraphRagDiagram />,
    reverse: true,
  },
  {
    index: 4,
    eyebrow: 'LLM AI AGENT',
    title: '스스로 일하는',
    titleAccent: 'LLM 기반 AI Agent',
    descriptions: [
      '계획·도구 실행·관찰을 반복하며 과업을 수행하는 자율 에이전트를 구축합니다.',
      'MCP·RAG·GraphRAG 도구를 연계해 복합 워크플로우를 오케스트레이션합니다.',
    ],
    tags: ['plan-act-observe', '오케스트레이션', '멀티툴', 'Workflow'],
    visual: <AgentChatDemo />,
  },
];
